import Vue from 'vue';

export default {
  toggleFilter(state, flag) {
    state.isOpen = flag;
  },
  isActiveFilter(state, flag) {
    state.isActive = flag;
  },
  isNotFound(state, flag) {
    state.isNotFound = flag;
  },
  isDisable(state, flag) {
    state.isDisable = flag;
  },
  setCurrentFilter(state, currentFilter) {
    Vue.set(state, 'currentFilter', currentFilter);
  },
  setSavedFilters(state, filters) {
    Vue.set(state, 'savedFilters', filters);
  },
  setActiveFilters(state, activeFilters) {
    Vue.set(state, 'activeFilters', activeFilters);
  },
  updateActiveFilter(state, payload) {
    const activeFilters = { ...state.activeFilters };

    if (payload.type === 'list') {
      activeFilters[payload.type].common = {
        ...payload.filter,
      };
    } else {
      activeFilters[payload.type] = {
        ...payload.filter,
      };
    }

    Vue.set(state, 'activeFilters', activeFilters);
  },
  updateCurrentFilter(state, payload) {
    const updated = {
      ...state.currentFilter,
      ...payload,
    };

    Vue.set(state, 'currentFilter', updated);
  },
  addSavedFilter(state, filter) {
    const savedFilters = { ...state.savedFilters };

    if (!savedFilters[filter.type]) {
      savedFilters[filter.type] = [];
    }
    savedFilters[filter.type].push(filter);

    Vue.set(state, 'savedFilters', savedFilters);
  },
  removeSavedFilterByIdAndType(state, payload) {
    const savedFilters = { ...state.savedFilters };
    let filters = savedFilters[payload.type];

    filters = filters.filter(filter => filter.id !== payload.filterId);
    savedFilters[payload.type] = filters;

    Vue.set(state, 'savedFilters', savedFilters);
  },
  updateFilterName(state, payload) {
    const savedFilters = { ...state.savedFilters };
    const filters = savedFilters[payload.type];
    const filter = filters.find(item => item.id === payload.id);

    if (filter) {
      const index = filters.indexOf(filter);

      const updated = {
        ...filter,
        name: payload.name,
      };

      filters.splice(index, 1, updated);
      savedFilters[payload.type] = filters;

      Vue.set(state, 'savedFilters', savedFilters);
    }
  },
  updateAdvancedSettingsByFilterType(state, payload) {
    const settings = state.advancedSettings[payload.type];

    if (settings) {
      const updatedFilterSettings = {
        ...settings,
        ...payload.settings,
      };

      const updatedSettings = {
        ...state.advancedSettings,
        [payload.type]: updatedFilterSettings,
      };

      Vue.set(state, 'advancedSettings', updatedSettings);
    }
  },
};
